<template>
  <div>
    <div class="tab-pane in active">
      <h4><strong>มินิบาคาร่า</strong></h4>
      <p>
        TECHPLAY มีเกมมินิบาคาร่าโดยมีตัวเลือกการเดิมพันที่คล้ายกับบาคาร่าทั่วไป
        ผลจะถูกกำหนดตามกฎด้านล่าง
        และระบบการแจกไพ่แบบสุ่มอัตโนมัติช่วยให้เกิดความเป็นธรรมสำหรับผู้เล่นทุกคน.
      </p>
      <p>
        มีตัวเลือกการเดิมพันหลัก 3 แบบสำหรับผู้เล่น ได้แก่ ผู้เล่น (Player), เจ้ามือ
        (Banker) และเสมอ (Tie) นอกจากนี้ยังมีตัวเลือกการเดิมพันข้างเคียงหลายแบบ
        ขึ้นอยู่กับแต้ม แต่ละฝั่งจะเปิดไพ่สองใบแรกหรือจั่วไพ่ใบที่สาม
        โดยแต่ละฝั่งสามารถมีไพ่สูงสุด 3 ใบ ฝั่งที่ใกล้เคียงกับ 9
        คะแนนมากที่สุดจะเป็นผู้ชนะ.
      </p>
      <p>รูปแบบการเดิมพันในเกมบาคาร่า:</p>
      <ul>
        <li>การเดิมพันที่ ผู้เล่น / เจ้ามือ / เสมอ</li>
        <li>การเดิมพันที่ ผู้เล่นไพ่คู่ / เจ้ามือไพ่คู่</li>
        <!-- <li>Cược tổng điểm Tài/Xỉu</li>
      <li>Cược tổng điểm Lẻ/Chẵn</li> -->
      </ul>
      <p><strong>หมายเหตุ:</strong></p>
      <p>
        - การเดิมพันที่ ผู้เล่น / เจ้ามือ / เสมอ: หากผลออกเสมอ
        การเดิมพันที่ผู้เล่นและเจ้ามือจะได้รับการคืนเงินเดิมพัน
      </p>
      <p>
        หากไม่มีการออกผลอย่างเป็นทางการเป็นช่วงเวลานาน TECHPLAY
        ขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การเดิมพันเป็นโมฆะ
        หรือประกาศว่าเกมนั้นไม่ถูกต้องสำหรับรอบหรือการออกผล โดยเฉพาะ
        หากผลถูกประกาศก่อนที่ระบบจะหยุดรับเดิมพัน.
      </p>
      <ol>
        <li>
          <h5 class="color-white">การเดิมพันที่ ผู้เล่น / เจ้ามือ / เสมอ</h5>
          <p>
            TECHPLAY จะกำหนดอัตราต่อรองที่สอดคล้องกัน และผลบาคาร่าจะแบ่งเป็น "ผู้เล่น"
            "เจ้ามือ" หรือ "เสมอ"
          </p>
          <p>
            ตัวอย่าง: ผลบาคาร่าคือ ผู้เล่นมี 7 แต้ม และ เจ้ามือมี 5 แต้ม เนื่องจาก 5
            น้อยกว่า 7 การเดิมพันของ "ผู้เล่น" จะชนะ แต่หากผลคือ เสมอ
            จะทำการคืนเงินเดิมพันของผู้เล่นและเจ้ามือทั้งหมด.
          </p>
        </li>
        <li>
          <h5 class="color-white">การเดิมพันไพ่คู่</h5>
          <p>ผู้เล่นไพ่คู่ จะชนะเมื่อไพ่สองใบแรกเป็นไพ่คู่ หรือ เลขเดียวกัน</p>
          <p>เจ้ามือไพ่คู่ จะชนะเมื่อไพ่สองใบแรกเป็นไพ่คู่ หรือ เลขเดียวกัน</p>
        </li>
      </ol>
    </div>

    <div>
      <h4><strong>เหรียญสีนำโชค</strong></h4>
      <p>
        เกมเหรียญสีนำโชคจะเล่นแบบสุ่มจากสี่เหรียญที่แตกต่างกันเพื่อหาผลลัพธ์
        ซึ่งแต่ละเหรียญจะมีสองแถบ (คือแถบสีแดงและสีขาว).
      </p>
      <p>
        ผลลัพธ์ทั้งหมดถูกสร้างขึ้นโดยระบบ RNG (Random Number Generator)
        ซึ่งรับประกันความสุ่มและความเป็นธรรม เกมเหรียญสีนำโชคของเรามีระยะเวลารอ 30 วินาที.
      </p>
      <p>รูปแบบการเดิมพันในเกมเหรียญสีนำโชค:</p>
      <ol class="c">
        <li>
          <h5 class="color-white">ผล Xoc Dia</h5>
          <ol class="k">
            <li>
              เรามีอัตราการจ่ายเงินที่แตกต่างกันขึ้นอยู่กับผลซึ่งคำนวณจาก "ผล Xoc Dia"
              <ol class="n">
                <li>ผล 4 เหรียญสีขาว</li>
                <li>ผล 3 เหรียญสีขาว และ 1 เหรียญสีแดง</li>
                <li>ผล 1 เหรียญสีขาว และ 3 เหรียญสีแดง</li>
                <li>ผล 4 เหรียญสีแดง</li>
                <li>ผล 2 เหรียญสีขาว และ 2 เหรียญสีแดง</li>
              </ol>
            </li>
            <li>
              ตัวอย่าง: ผลที่ออกมาคือ แดง, แดง, ขาว, แดง จำนวนสีแดง 3 เหรียญและจำนวนสีขาว
              1 เหรียญ หากเดิมพัน "1 ขาว, 3 แดง" จะชนะการเดิมพัน
            </li>
          </ol>
        </li>
        <li>
          <h5 class="color-white">คี่/คู่</h5>
          <ol class="k">
            <li>
              เราจะกำหนดว่าเป็น "คี่" หรือ "คู่" ตามจำนวนเหรียญสีแดงหรือสีขาวในผลที่ออกมา.
              <ol class="n">
                <li>คี่ คือ จำนวนเหรียญสีขาวและสีแดงมีเป็นจำนวนคี่</li>
                <li>คู่ คือ จำนวนเหรียญสีขาวและสีแดงมีเป็นจำนวนคู่</li>
              </ol>
            </li>
            <li>
              ตัวอย่าง: ผลที่ออกมาคือ แดง, แดง, ขาว, แดง จำนวนสีแดง 3 เหรียญและจำนวนสีขาว
              1 เหรียญ ดังนั้นการเดิมพัน "คี่" จะชนะการเดิมพัน
            </li>
          </ol>
        </li>
      </ol>
      <p>
        เราขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การออกผลใด ๆ ที่ได้รับผลกระทบเป็นโมฆะ
        เมื่อไม่สามารถออกผลอย่างเป็นทางการได้ในระยะเวลาที่ยาวนานหรือเมื่อมีการประกาศผลอย่างเป็นทางการก่อนที่ระบบจะหยุดรับเดิมพัน.
      </p>
    </div>

    <div>
      <h4><strong>ใหญ่ เล็ก</strong></h4>
      <p>
        เกม ใหญ่ เล็ก จะเล่นตามผลที่ออกจากลูกเต๋า 3 ลูก ผลจะออกโดยระบบ RNG
        ซึ่งรับประกันความสุ่มและความเป็นธรรม.
      </p>
      <p>เรามีเกม ใหญ่ เล็ก ที่มีระยะเวลารอ 30 วินาที.</p>
      <p>รูปแบบการเดิมพันในเกมใหญ่ เล็ก:</p>
      <ol class="c">
        <li>
          <h5 class="color-white">ผลรวม สูง/ต่ำ</h5>
          <ol class="k">
            <li>
              ผลรวม ใหญ่/เล็ก คือการเดิมพันจากผลรวมของลูกเต๋า 3 ลูก โดยมีแต้มระหว่าง 3-18
              แต้ม
            </li>
            <li>สูง คือการเดิมพันผลรวมของลูกเต๋า 3 ลูกและมีแต้มระหว่าง 11-18 แต้ม</li>
            <li>ต่ำ คือการเดิมพันผลรวมของลูกเต๋า 3 ลูกและมีแต้มระหว่าง 3-10 แต้ม</li>
          </ol>
        </li>
        <li>
          <h5 class="color-white">เดิมพันหมายเลข</h5>
          <ol class="k">
            <li>
              การวางเดิมพันหมายเลขคือการทายว่าจะมีหมายเลขที่เลือกปรากฏบนลูกเต๋า 3 ลูก
            </li>
            <li>
              ตัวอย่าง: เกมใหญ่เล็ก ผลที่ออกมาคือ 1, 1, 3 ดังนั้นการเดิมพันที่หมายเลข "1"
              และ "3" จะชนะ การเดิมพันที่หมายเลข "1"
              จะได้รับการจ่ายเงินเพิ่มเติมตามจำนวนผลที่ออกมาสองลูก.
            </li>
          </ol>
        </li>
      </ol>
      <p>
        หากไม่มีการออกผลอย่างเป็นทางการเป็นช่วงเวลานาน TECHPLAY
        ขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การเดิมพันเป็นโมฆะ
        หรือประกาศว่าเกมนั้นไม่ถูกต้องสำหรับรอบหรือการออกผล โดยเฉพาะ
        หากผลถูกประกาศก่อนที่ระบบจะหยุดรับเดิมพัน.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
ol.a {
  list-style-type: armenian;
}
ol.b {
  list-style-type: cjk-ideographic;
}
ol.c {
  list-style-type: decimal;
}
ol.d {
  list-style-type: decimal-leading-zero;
}
ol.e {
  list-style-type: georgian;
}
ol.f {
  list-style-type: hebrew;
}
ol.g {
  list-style-type: hiragana;
}
ol.h {
  list-style-type: hiragana-iroha;
}
ol.i {
  list-style-type: katakana;
}
ol.j {
  list-style-type: katakana-iroha;
}
ol.k {
  list-style-type: lower-alpha;
}
ol.l {
  list-style-type: lower-greek;
}
ol.m {
  list-style-type: lower-latin;
}
ol.n {
  list-style-type: lower-roman;
}
ol.o {
  list-style-type: upper-alpha;
}
ol.p {
  list-style-type: upper-latin;
}
ol.q {
  list-style-type: upper-roman;
}
ol.r {
  list-style-type: none;
}
ol.s {
  list-style-type: inherit;
}
</style>
